import { PropsWithChildren, createContext, useContext } from "react";

import { Country, CountryCode, VerificationMode, VerifyParams } from "../types";

type ContextType = {
  cellphone: string;

  country: Country;
  setCountry: (country: Country) => void;

  createLoginCode: (
    countryCode: CountryCode,
    phone: string,
    mode?: VerificationMode
  ) => Promise<void>;

  onVerify: (params: VerifyParams) => Promise<void>;
  onAskForHelp: (message: string) => void;
  onError: (error: unknown, ctx?: object) => void;
};
export type { ContextType as TLoginContext };

const Context = createContext<ContextType | null>(null);

export default function useLogin() {
  const ctx = useContext(Context);
  if (!ctx) throw new Error("Missing LoginProvider");
  return ctx;
}

export function LoginProvider({
  children,
  ...props
}: PropsWithChildren<ContextType>) {
  return <Context.Provider value={props}>{children}</Context.Provider>;
}
